import {useFluxServices} from "injection/hooks";
import {useLocalUserPublicPreferences} from "modules/stores/ui/persistedStore";

/**
 * Hook to check if internal features should be shown to the current user.
 *
 * This hook returns a boolean that is true only when:
 * 1. Claims have finished loading
 * 2. User has the "internal" claim
 * 3. Either the showInternalFeatures localStorage toggle is enabled (defaults to true),
 *    OR the forceShow parameter is true (e.g., when alt key is held)
 *
 * Returns false while claims are still loading (safe default).
 *
 * @param forceShow - Optional override to show internal features even when showInternalFeatures is disabled
 *                    (e.g., when holding alt/option key)
 * @returns boolean - true if internal features should be shown, false otherwise
 */
export function useHasInternalAccess(forceShow = false): boolean {
    const {useFluxClaimsStore} = useFluxServices();
    const showInternalFeatures = useLocalUserPublicPreferences((state) => state.showInternalFeatures);

    const hasInternalAccess = useFluxClaimsStore((state) => !state.isLoading && !!state.claims.internal);

    return hasInternalAccess && (showInternalFeatures || forceShow);
}
